import React from 'react';
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import HomePage from "./screens/HomePage";
import {TechnicalSupport} from "./screens/services/TechnicalSupport";
import {MicrosoftService} from "./screens/services/MicrosoftService";
import {NetworkSupport} from "./screens/services/NetworkSupport";
import {CloudMigration} from "./screens/services/CloudMigration";
import {SecurityCameras} from "./screens/services/SecurityCameras";
import {NonProfits} from "./screens/services/NonProfits";
import {CyberSecurity} from "./screens/services/CyberSecurity";
import ContactUs from "./screens/ContactUs";

const App: React.FC = () =>  {
  return (
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services/technical-support" element={<TechnicalSupport />} />
          <Route path="/services/microsoft-service" element={<MicrosoftService />} />
          <Route path="/services/network-security" element={<NetworkSupport />} />
          <Route path="/services/cloud-migration" element={<CloudMigration />} />
          <Route path="/services/security-cameras" element={<SecurityCameras />} />
          <Route path="/services/non-profits" element={<NonProfits />} />
          <Route path="/services/cybersecurity" element={<CyberSecurity />} />
          <Route path="/contact-us" element={<ContactUs />} />
        </Routes>
      </Router>
  )
}

export default App;
